import React, { useState, useEffect, useCallback } from 'react';
import { socialLinks } from '../data/siteLinks';

interface Testimonial {
  name: string;
  text: string;
}

const testimonials: Testimonial[] = [
  {
    name: 'Yusuf K.',
    text: 'Almanya Fırsat Kartı başvurusu sürecimde Ayşegül Saraç Hanım sayesinde kendimi hiç yalnız hissetmedim.',
  },
  {
    name: 'Irmak F.',
    text: 'Almanya Aile birleşimi vizesi ile ilgili Ayşegül Hanım’dan genel bilgi aldım aldım.',
  },
  {
    name: 'Halil B.',
    text: 'Ayşegül Hanım ilgili ve her zaman ulaşılabilir. Ondan Almanya hakkında genel bilgi almak benim için büyük bir şanstı.',
  },
  {
    name: 'Esra A.',
    text: "Kendisini YouTube videolarıyla tanıdığım Ayşegül Hanım’la iletişime geçmek yaptığım en doğru şey oldu. Çok pozitif bir kişi. Ayrıca güven veren enerjisiyle bu zorlu süreçte insanın içi rahat oluyor. Gönül rahatlığı ile kendisiyle iletişime geçebilirsiniz.",
  },
  {
    name: 'Işıl İlkem E.',
    text: 'Ayşegül Hanım ile yaptığımız görüşme çok verimliydi. Güler yüzlü, açık bir iletişimi var ve çok içten biri. Önemli bilgiler edindik. Her şey yolunda giderse kendisiyle tekrar görüşmeyi kesinlikle isteriz. Teşekkür ederiz!',
  },
];

const Testimonials: React.FC = () => {
  const [current, setCurrent] = useState(0);
  const [isPaused, setIsPaused] = useState(false);

  const next = useCallback(() => {
    setCurrent((prev) => (prev + 1) % testimonials.length);
  }, []);

  const prev = useCallback(() => {
    setCurrent((prev) => (prev - 1 + testimonials.length) % testimonials.length);
  }, []);

  useEffect(() => {
    if (isPaused) return;
    const timer = setInterval(next, 5000);
    return () => clearInterval(timer);
  }, [isPaused, next]);

  return (
    <section
      id="google-yorumlari"
      className="testimonials-section"
      onMouseEnter={() => setIsPaused(true)}
      onMouseLeave={() => setIsPaused(false)}
    >
      <div className="container">
        <div className="google-reviews-shell">
          <div className="google-reviews-summary">
            <span className="google-g-mark" role="img" aria-label="Google">G</span>
            <div className="google-reviews-score-row">
              <strong>5,0</strong>
              <span className="google-reviews-stars" aria-label="5 üzerinden 5 yıldız">★★★★★</span>
            </div>
            <a href={socialLinks.google} target="_blank" rel="noopener noreferrer">
              35 yorumu görün <span aria-hidden="true">↗</span>
            </a>
          </div>

          <div className="google-reviews-content">
            <div className="testimonials-carousel">
              <button className="testimonial-arrow testimonial-arrow-prev" onClick={prev} aria-label="Önceki yorum">
                <svg width="11" height="22" viewBox="0 0 14 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 2L2 12L12 22" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </button>
              <div className="testimonial-slide">
                <p className="testimonial-text">“{testimonials[current].text}”</p>
                <div className="testimonial-author">— {testimonials[current].name}</div>
              </div>
              <button className="testimonial-arrow testimonial-arrow-next" onClick={next} aria-label="Sonraki yorum">
                <svg width="11" height="22" viewBox="0 0 14 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M2 2L12 12L2 22" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
